module.exports = __webpack_public_path__ + "img/miryoku_t2.238cb08a.png";